import React from 'react';
import { Divider as ChakraDivider, DividerProps as ChakraDividerProps } from '@chakra-ui/react';

export function Divider(props: ChakraDividerProps) {
  return <ChakraDivider {...props} />;
}
